import React, { Component } from 'react';
import axios from 'axios';
import 'moment/locale/pt';

import AuxRoutines from './AuxRoutines';
import InsightcareHeaderPS from './components/PainelPSMonitoramento/components/InsightcareHeaderPS';
import CardsList from './components/PainelPSMonitoramento/components/CardsList';
import LoadingPS from './components/PainelPSMonitoramento/components/LoadingPS';
import { montarDadosPacientes, montarInfoCards, getUrlProbabilidadeInternacao } from './components/PainelPSMonitoramento/helpers/MontagemDados';
import { carregarRegrasSLA } from './components/PainelPSMonitoramento/rules/regraSLA';
import { configurarRegraFilaPS } from './components/PainelPSMonitoramento/rules/regraFilaPS';

import { BACKEND_URL, BACKEND_INS_URL } from './config/constants';
import TelaBuscaPaciente from './components/PainelPSMonitoramento/screens/TelaBuscaPaciente';
import TelaDetalhe from './components/PainelPSMonitoramento/screens/TelaDetalhe';
import TelaPrincipal from './components/PainelPSMonitoramento/screens/TelaPrincipal';

//require('moment/locale/pt-BR');

class PainelPSMonitoramento extends Component {

  constructor(props) {
    super(props);
    const { match: { params } } = this.props;

    if (!AuxRoutines.temPainelMonitoramentoPS(params.base, params.company)) {
      // apresenta uma mensagem na tela: Painel Indisponível para a base/empresa selecionada em tela (sem alert)
      this.state = {
        base: params.base,
        company: params.company,
        title: 'Monitoramento de PS',
        dataCards: null,
        dataDetalhada: [],
        dataPacientes: {},
        dataProbabilidadeInternacao: {},
        dataDorToracica: null,
        dataAVCDerrame: null,
        tipoSelecionado: null,
        pacienteSelecionado: null,
        painelIndisponivel: true,
        mostrarLocais: false,
      };
    } else {
      this.state = {
        base: params.base,
        company: params.company,
        title: 'Monitoramento de PS',
        dataCards: montarInfoCards(null),
        dataDetalhada: [],
        dataPacientes: {},
        dataProbabilidadeInternacao: {},
        dataDorToracica: null,
        dataAVCDerrame: null,
        tipoSelecionado: null,
        pacienteSelecionado: null,
        mostrarLocais: false,
        loading: true,
      };
      this.loadRequiredData = this.loadRequiredData.bind(this)
      this.intervalId = null;
    }
  }

  async componentDidMount() {
    // regra de fila (PS Adulto x PS Infantil) e regras de SLA são definidas uma única vez ao entrar na tela
    configurarRegraFilaPS({ base: this.state.base, company: this.state.company });
    await carregarRegrasSLA({ base: this.state.base, company: this.state.company });
    this.loadRequiredData();
    this.intervalId = setInterval(this.loadRequiredData, 60000);
  }

  componentWillUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  async loadRequiredData() {
    const requestData = await this.requestData();
    const dataDetalhada = requestData.dataDetalhada;
    const dataDorToracica = requestData.dataDorToracica[0]?.DS_SENHA ?? null;
    const dataAVCDerrame = requestData.dataAVCDerrame[0]?.DS_SENHA ?? null;
    const dataProbabilidadeInternacao = requestData.dataProbabilidadeInternacao;

    const dataCards = montarInfoCards(dataDetalhada);
    const dataPacientes = montarDadosPacientes(dataDetalhada);

    this.setState({ dataCards, dataDorToracica, dataAVCDerrame, dataDetalhada, dataPacientes, dataProbabilidadeInternacao, loading: false });
  }

  async requestData() {
    const baseUrl = BACKEND_URL + '/command-center/';
    let params = "?base=" + this.state.base;
    if (this.state.company !== undefined && this.state.company !== null) {
      params = params + "&company=" + this.state.company;
    }

    if (!AuxRoutines.temPainelMonitoramentoPS(this.state.base, this.state.company)) {
      return {
        dataDorToracica: null,
        dataAVCDerrame: null,
        dataDetalhada: {},
        dataProbabilidadeInternacao: {},
      };
    }

    const requests = [
      axios.get(`${baseUrl}ps-monitoramento-dor-toracica${params}`),
      axios.get(`${baseUrl}ps-monitoramento-avc-derrame${params}`),
      axios.get(BACKEND_INS_URL + '/mon-pacientes-atendimento/list-probabilidade-internacao?sharedSecret=hd783g4kshd7f9fhalu&token=hgoDjUMCQh67e6WviiK0KuiDt8UxNI&previsaoMin=50'),
      ...CardsList.map(card => axios.get(`${baseUrl}ps-monitoramento-painel-detalhe${params}&tipo=${card.tipo}`))
    ];

    const results = await Promise.allSettled(requests);

    const getResponseData = (res) =>
      res.status === 'fulfilled' && res.value.data?.Status
        ? res.value.data.ResponseData
        : {};

    const getReturnData = (res) =>
      res.status === 'fulfilled' && res.value.data?.Status
        ? res.value.data.ReturnData
        : {};

    const dataDorToracica = getResponseData(results[0]);
    const dataAVCDerrame = getResponseData(results[1]);
    const dataProbabilidadeInternacao = getReturnData(results[2]).Pacientes ?? [];
    const dataDetalhada = {};

    CardsList.forEach((card, index) => {
      dataDetalhada[card.tipo] = getResponseData(results[index + 3]);
    });

    return { dataDorToracica, dataAVCDerrame, dataDetalhada, dataProbabilidadeInternacao };
  }

  abrirCard = (tipoSelecionado) => {
    const cardSelecionado = CardsList.find(card => card.tipo === tipoSelecionado);
    const title = cardSelecionado?.title;

    this.setState({ tipoSelecionado, title });
  }

  fecharCard = () => {
    this.setState(prev => {
      const cardSelecionado = CardsList.find(card => card.tipo === prev.tipoSelecionado);

      if (prev.pacienteSelecionado) {
        return { pacienteSelecionado: null, title: cardSelecionado?.title };
      }

      if (prev.tipoSelecionado) {
        return { tipoSelecionado: null, title: 'Monitoramento de PS' };
      }

      return null;
    });
  };

  alternarLocais = () => {
    this.setState(prev => ({ mostrarLocais: !prev.mostrarLocais }));
  };

  selecionarPaciente = (codigoPaciente) => {
    this.setState(prev => {
      const limpar = codigoPaciente == null;
      const cardSelecionado = CardsList.find(card => card.tipo === prev.tipoSelecionado);

      return {
        pacienteSelecionado: codigoPaciente,
        title: limpar
          ? cardSelecionado?.title
          : 'Detalhes do Paciente'
      };
    });
  }

  render() {
    const { dataCards, dataDetalhada, dataPacientes, dataDorToracica, dataAVCDerrame, tipoSelecionado, pacienteSelecionado, title, dataProbabilidadeInternacao } = this.state;
    // se dataCards = null, não apresenta os Cards na tela
    if (this.state.dataCards === null) {
      return (
        <div className={"App"}>
          <InsightcareHeaderPS title={title} dataDorToracica={dataDorToracica} dataAVCDerrame={dataAVCDerrame} dataPacientes={dataPacientes} tipoSelecionado={tipoSelecionado} pacienteSelecionado={pacienteSelecionado} selecionarPaciente={this.selecionarPaciente} onVoltar={this.fecharCard} base={this.state.base} company={this.state.company} mostrarLocais={this.state.mostrarLocais} alternarLocais={this.alternarLocais} />
          <main id="painelPSMonitoramento">
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', fontSize: '1.5em', color: '#555' }}>
              <p>Painel Indisponível nesta Unidade</p>
            </div>
          </main>
        </div>
      );
      // ignore o resto do código, que apresenta os Cards normalmente quando dataCards é diferente de null
    }

    let tela = <TelaPrincipal dataCards={dataCards} abrirCard={this.abrirCard} />;

    // na primeira carga, apresenta o loading no lugar dos Cards
    if (this.state.loading) {
      tela = <LoadingPS />;
    } else if (tipoSelecionado != null) {
      tela = <TelaDetalhe dataDetalhada={dataDetalhada} dataProbabilidadeInternacao={dataProbabilidadeInternacao} tipoSelecionado={tipoSelecionado} abrirCard={this.abrirCard} selecionarPaciente={this.selecionarPaciente} />;

      if (pacienteSelecionado != null) {
        tela = <TelaBuscaPaciente dataPacientes={dataPacientes} dataProbabilidadeInternacao={dataProbabilidadeInternacao} pacienteSelecionado={pacienteSelecionado} selecionarPaciente={this.selecionarPaciente} />;
      }
    }

    return (
      <div className={"App"}>
        <InsightcareHeaderPS title={title} dataDorToracica={dataDorToracica} dataAVCDerrame={dataAVCDerrame} dataPacientes={dataPacientes} tipoSelecionado={tipoSelecionado} pacienteSelecionado={pacienteSelecionado} selecionarPaciente={this.selecionarPaciente} onVoltar={this.fecharCard} urlProbabilidadeInternacao={getUrlProbabilidadeInternacao(this.state.base, this.state.company)} base={this.state.base} company={this.state.company} mostrarLocais={this.state.mostrarLocais} alternarLocais={this.alternarLocais} />
        <main id="painelPSMonitoramento">
          {tela}
        </main>
      </div>
    );
  }
}

export default PainelPSMonitoramento;
